import React from 'react';
import styles from './ReviewContents.scss';
import classNames from 'classnames/bind';
import ReviewBox from 'web/components/common/ReviewBox';

const cx = classNames.bind(styles);

function ReviewContents({ review = [], handleModalClose, handleReviewShow }) {
  console.log('모달 reviewList', { review });

  return (
    <div>
      <div className="review-hide-btn-wrap" onClick={() => handleModalClose()}>
        <img
          src="https://image.okaydoctor.co.kr/image/m-popup-btn-down-2.png"
          alt=""
        />
      </div>
      <div className={cx('ReviewContents')}>
        <div className="review-content-wrap">
          <ul className="review-content">
            {review.map((data, i) => {
              let dateTime = '';
              let reviewMsg = '';
              let reviewnickname = '';
              dateTime = data.regDateAsString.substr(0, 10);

              if (data.message.length >= 36) {
                reviewMsg = data.message.substr(0, 35).concat('...');
              } else {
                reviewMsg = data.message;
              }

              reviewnickname = data.nickname.substr(0, 2).concat('*****');

              // console.log({ dateTime });
              return (
                <li>
                  <div className="review-card">
                    <img
                      src={data.contentsThumbnail}
                      alt={'review-img'}
                      className="review-card-image"
                      onClick={() => handleReviewShow(i)}
                    />
                    <div className="review-card-text">{reviewMsg}</div>
                    <div className="review-date">
                      <div className="start">
                        <ReviewBox type={`micro`} star={data.scoreRate} />
                      </div>
                      <div className="date">
                        <span>
                          {reviewnickname} | {dateTime}
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ReviewContents;
